import { render, staticRenderFns } from "./MyselfTask.vue?vue&type=template&id=16811923&scoped=true&"
import script from "./MyselfTask.vue?vue&type=script&lang=js&"
export * from "./MyselfTask.vue?vue&type=script&lang=js&"
import style0 from "./MyselfTask.vue?vue&type=style&index=0&id=16811923&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16811923",
  null
  
)

export default component.exports